import { createFileRoute, Outlet } from '@tanstack/react-router';
import { RoleGuard } from '@/components/molecules/role-guard';
import { useHotelAccess } from '@/lib/hooks/use-hotel-access';

export const Route = createFileRoute('/protected/_layout/hotel/_layout')({
  component: HotelLayout,
});

export function HotelLayout() {
  const { canReadHotel, isLoading } = useHotelAccess();
  return (
    <RoleGuard hasAccess={canReadHotel} isLoading={isLoading}>
      <Outlet />
    </RoleGuard>
  );
}
